import { render, staticRenderFns } from "./TaskInfo.vue?vue&type=template&id=27165de9"
import script from "./TaskInfo.vue?vue&type=script&lang=js"
export * from "./TaskInfo.vue?vue&type=script&lang=js"
import style0 from "./TaskInfo.vue?vue&type=style&index=0&id=27165de9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports